const MULTIFIELDS = ['MULTIPICKLIST', 'MULTIREFERENCE', 'POLYMULTIREFERENCE']

export default ({ type, error, style }) => ({
  control: (base, state) => ({
    ...base,
    border: `1px solid ${error ? 'var(--invalidRed)' : 'var(--paleGrey)'}`,
    borderRadius: 'var(--borderRadius)',
    backgroundColor: 'white',
    overflow: 'hidden',
    cursor: 'text',
    color: state.isFocused ? '#495057' : 'inherit',
    borderColor: state.isFocused ? error && 'var(--invalidRed) !important' || '#80bdff !important' : error && 'var(--invalidRed) !important' || '#ced4da !important',
    outline: 0,
    boxShadow: state.isFocused ? `0 0 0 0.2rem ${(error && 'var(--invalidRedOutline) !important') || 'rgba(0,123,255,.25)'}` : 'none',
    height: MULTIFIELDS.includes(type) ? 'auto' : 'calc(1.75rem + 2px)',
    maxHeight: MULTIFIELDS.includes(type) ? 'none' : '100%',
    minHeight: MULTIFIELDS.includes(type) ? 'calc(1.75rem + 2px)' : 'unset !important'
  }),
  container: (base, state) => ({
    ...base,
    display: 'block',
    height: '100%',
    minHeight: '100%',
    width: '100%',
    outline: state.isFocused && 0,
    ...(style || {})
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999999
  }),
  multiValue: base => ({
    ...base,
    height: '100%',
    minWidth: 'auto'
  }),
  multiValueLabel: (base) => ({
    ...base,
    alignItems: 'center',
    display: 'flex'
  }),
  valueContainer: base => ({
    ...base,
    height: '100%',
    flexWrap: MULTIFIELDS.includes(type) ? 'wrap' : 'nowrap',
    padding: MULTIFIELDS.includes(type) ? '1px 1rem 1px .2rem' : '.375rem 1rem .375rem calc(.375rem - 2px)'
  }),
  clearIndicator: base => ({
    ...base,
    margin: 'auto',
    padding: 0
  }),
  dropdownIndicator: base => ({
    ...base,
    padding: '4px',
    margin: '0 !important'
  })
})
